import { render, staticRenderFns } from "./previous-next-buttons.component.vue?vue&type=template&id=db547916"
import script from "./previous-next-buttons.component.vue?vue&type=script&lang=js"
export * from "./previous-next-buttons.component.vue?vue&type=script&lang=js"
import style0 from "./previous-next-buttons.component.vue?vue&type=style&index=0&id=db547916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports